
module dg.lists {

    class ViewSwitcherController {

        public compositeDisplayers: dg.actions.ICompositeDisplayerOptions[];
        public compositeDisplayer: dg.actions.ICompositeDisplayerOptions;

        $onInit = () => {
           
        }

        public changeCompositeDisplayer(compositeDisplayer) {
            this.compositeDisplayer = compositeDisplayer;
        }

        //public toggleDisplayers() {
        //    this.compositeDisplayer = this.compositeDisplayers.
        //}
    } 

    angular.module('dg.lists').component('viewSwitcher', {
        bindings: {
            compositeDisplayer: '=',
            compositeDisplayers: '<'
        },
        controller: ViewSwitcherController,
        templateUrl: '/digmo/src/lists/view-switcher.html'
    });
}